(function SoarDashboard($, Adzuki) {
	"use strict";

	var soar_loaded = false;
	let filters = {};
	let sectionName;
	
	$(document).ready(function onDocumentReady() {
		Adzuki.onload(
			'main/index',
			function onMainIndex() {
				$('#soar').on('loadSoar', loadSoarDashboard);

				if ($('#soar-dashboard').hasClass('active')) {
					loadSoarDashboard();
				}
			},
			false
		);
	});

	function loadSoarDashboard() {
		if (soar_loaded === true) {
			return;
		}

		soar_loaded = true;

		Adzuki.Ajax.get('/main/soar').then(function displaySoar(response) {
			$('#soar').html(response);

			Adzuki.Chart.reload();

			featuredGoals();
			departedSalesRevenue();
			departedSales();
			purchasedSalesRevenue();
			purchasedSales();
			stlyComparison();
			bookingProjections();
			starLevelTrending();

			$(document).on('click', 'a.soar_filter', selectSoarFilter);
			$(document).on('change', '.soar_filter_form', soarFilter);

			$(document).on('click', '.nav-tabs li a', function tabClick(e) {
				e.preventDefault();
				e.data = {};
				e.data.sectionName = $(this).data('section-name');
				populateFilterCustomDates(e);
			});

			$('form.soar_filter_form').change();

			$('.analysis').on('click', function _showHideAnalysisArea(e) {
				e.preventDefault();

				if ($('.analysis-data').css('display') === 'none') {
					$('.analysis-data').slideDown();
					Adzuki.Ajax.get('/SoarDashboard/analysis')
						.then(function analysis(response) {
							$('.analysis-data').html(response);
						})
						.done(function _afterLoad() {
							$('.custom-date-range', '.analysis-data').each(function _associateOnClick() {	
								sectionName = $(this).data('date-range-class');	

								$('#' + sectionName + '_filter_button').on('click', { sectionName }, function _afterClick(ev) {
									ev.preventDefault();
									populateFilterCustomDates(ev);
								});

								$('#soar_filter_' + sectionName, '.analysis-data').change();
							});
							Adzuki.Form.initAjaxForm('SoarCustomDates');
						});

					$(this).html('Hide Detailed Analysis');
				} else {
					$('.analysis-data').slideUp();
					$(this).html('View Detailed Analysis');
				}
			});

			Adzuki.QTip.attachQtip();

			Adzuki.Form.initAjaxForm('SoarCustomDates');

			$( '.custom-date-range' ).each(function _associateOnClick() {
				sectionName = $(this).data('date-range-class');
				$('#' + sectionName + '_filter_button').on('click', { sectionName }, populateFilterCustomDates);
			  });

			$(document).on('click', '.custom-date-range', function _showCustomDateRange(e) {
				e.preventDefault();
				sectionName = $(this).data('date-range-class'); 

				$('.' + sectionName + '_filter').addClass('hidden');
				$('.' + sectionName + '_filter_dates').removeClass('hidden');
			});

			$(document).on('click', '.cancel-custom-dates', function _hideCustomDateRange(e) {
				sectionName = $(this).data('date-range-class');

				$('.' + sectionName + '_filter').removeClass('hidden');
				$('.' + sectionName + '_filter_dates').addClass('hidden');

				e.preventDefault();
			});
		});

		setTimeout(
			function _resizeme() {
				$(window).trigger('resize');
			},
			500
		);
	}

	function populateFilterCustomDates(e) {
		const { data: { sectionName } } = e;

		const dateTo   = $('#' + sectionName + '_date_to').val();
		const dateFrom = $('#' + sectionName + '_date_from').val();
		
		let breakdown_type = '';

		if (Date.parse(dateFrom) > Date.parse(dateTo)) {
			Adzuki.StatusMessage('error', 'The start date must be before the end date');
			return false;
		} 

		let urlDates = dateFrom.replace(/\//g, '-') + '_' + dateTo.replace(/\//g, '-');

		if (dateTo.length === 0 || dateFrom.length === 0) {
			urlDates = 'cur_year';
		}

		if ($('#' + sectionName + '-departures').hasClass('active')) {
			breakdown_type = '/departures';
		} else if ($('#' + sectionName + '-purchases').hasClass('active')) {
			breakdown_type = '/purchases';
		}

		const url = filters[sectionName].url+urlDates+breakdown_type+(filters[sectionName].value?filters[sectionName].value:'');

		$('#' + sectionName + '_filter').text('Retrieving data...');
		$('.' + sectionName + '_filter').removeClass('hidden');
		$('.' + sectionName + '_filter_dates').addClass('hidden');

		Adzuki.Ajax.get(url)
			.then(function _(response) {
				$('#' + sectionName + '_container').html(response);
				$('#' + sectionName + '_filter').text(
					'Custom Date Range (' + dateFrom + ' - ' + dateTo + ') ' + filters[sectionName].filterDescriptions.join(' - ')
				);
			})
			.done(function _afterLoad() {
				let date_from = $('#' + sectionName + '_date_from').val();
				let date_to   = $('#' + sectionName + '_date_to').val();

				if (date_from === undefined || date_from.length === 0 || date_to === undefined || date_to.length === 0) {
					return;
				}

				const start_date = new Date(date_from);
				const end_date   = new Date(date_to);

				date_from = start_date.getFullYear() + '-' + (start_date.getMonth() + 1) + '-' + start_date.getDate().toString().padStart(2, '0');
				date_to   = end_date.getFullYear() + '-' + (end_date.getMonth() + 1) + '-' + end_date.getDate().toString().padStart(2, '0');

				let time_period = date_from + '_' + date_to;

				renderChartBySection(sectionName, time_period);
			});
	}

	function featuredGoals() {
		Adzuki.Ajax.get('/SoarDashboard/featuredGoals')
			.then(function goals(response) {
				$('#north-star-content').html(response);
			}
		);
	}

	// function financialSnapshot()
	// {
	// 	Adzuki.Ajax.get('/SoarDashboard/financialSnapshot')
	// 		.then(function renderfinancialSnapshot(response) {
	// 			$('#financial_snapshot_container').html(response);
	// 		}
	// 	);
	// }

	function departedSalesRevenue()
	{
		Adzuki.Ajax.get('/SoarDashboard/departedSalesRevenue')
			.then(function renderDepartedSalesRevenue(response) {
				$('#sales_by_departures').html(response);
			}
		);
	}

	function departedSales()
	{
		var chart = new Adzuki.Chart('#departed_sales', {
			width: '100%',
			title: '',
			vAxis: {
				title: 'Sales'
			},
			hAxis: {
				title: 'Years'
			},
			colors: ['#3366cc', '#ff0000', '#ffa500', '#128806', '#6b39b2', '#c90076']
		});

		var data;

		$(chart).on('ready', function _doIt() {
			Adzuki.Ajax.get('/SoarDashboard/departedSales')
				.then(function renderDepartedSales(response) {
					$('#departed_sales').html(response);
					$('#departed_sales').nextAll('.star-level-note:first').removeClass('hidden');

					data = $.parseJSON($('#departed_sales_data').val());
					chart.setData(data);
					chart.draw('column');

					setTimeout(
						function _resizeme() {
							$(window).trigger('resize');
						},
						500
					);
				}
			);
		});
	}

	// function expectedCommissions()
	// {
	// 	var chart = new Adzuki.Chart('#expected_commissions_chart', {
	// 		width: '100%',
	// 		title: '',
	// 		vAxis: {
	// 			title: 'Commissions Expected'
	// 		},
	// 		hAxis: {
	// 			title: 'Dates'
	// 		},
	// 		colors: ['#128806']
	// 	});

	// 	var data;

	// 	$(chart).on('ready', function _doIt() {
	// 		Adzuki.Ajax.get('/SoarDashboard/expectedCommissionsChart')
	// 			.then(function renderExpectedCommissionsChart(response) {
	// 				$('#expected_commissions_chart').html(response);

	// 				data = $.parseJSON($('#expected_commissions_data').val());
	// 				chart.setData(data);
	// 				chart.draw('column');

	// 				console.log('happening');

	// 				setTimeout(
	// 					function _resizeme() {
	// 						$(window).trigger('resize');
	// 					},
	// 					500
	// 				);
	// 			}
	// 		);
	// 	});
	// }

	function purchasedSalesRevenue()
	{
		Adzuki.Ajax.get('/SoarDashboard/purchasedSalesRevenue')
			.then(function renderDepartedSalesRevenue(response) {
				$('#sales_by_purchases').html(response);
			}
		);
	}

	function purchasedSales()
	{
		var chart = new Adzuki.Chart('#purchased_sales', {
			width: '100%',
			title: '',
			vAxis: {
				title: 'Sales'
			},
			hAxis: {
				title: 'Years'
			},
			colors: ['#3366cc', '#ff0000', '#ffa500', '#128806']
		});

		var data;

		$(chart).on('ready', function _doIt() {
			Adzuki.Ajax.get('/SoarDashboard/purchasedSales')
				.then(function renderPurchasedSales(response) {
					$('#purchased_sales').html(response);

					data = $.parseJSON($('#purchased_sales_data').val());
					chart.setData(data);
					chart.draw('column');

					setTimeout(
						function _resizeme() {
							$(window).trigger('resize');
						},
						500
					);
				}
			);
		});
	}

	function stlyComparison()
	{
		Adzuki.Ajax.get('/SoarDashboard/stlyComparison')
			.then(function renderStlyComparison(response) {
				$('#stly_comparison').html(response);
			}
		);
	}

	function bookingProjections()
	{
		Adzuki.Ajax.get('/SoarDashboard/bookingProjections')
			.then(function renderProjections(response) {
				$('#booking_projections').html(response);
			}
		);
	}

	function renderAnalysisChart(chart_type, breakdown_type, time_period)
	{
		var chart;
		let selector = '#' + chart_type + '-analysis-chart-' + breakdown_type;

		// Does this section have a chart
		if ($(selector)[0] === undefined) {
			return;
		}

		chart = new Adzuki.Chart(selector, {
			width: '100%',
			title: '',
			is3D : true
		});

		$(chart).on('ready', function chartReady() {
			Adzuki.Ajax.get('/Reports/analysisChart/' + chart_type + '/' + breakdown_type + '/' + time_period)
			.then(function getChartData(response) {
				chart.setData(response);
				chart.draw('pie');
			});
		});
	}

	function starLevelTrending()
	{
		Adzuki.Ajax.get('/SoarDashboard/starLevelTrending')
			.then(function goals(response) {
			$('.star-level-trending').html(response);
			$('.star-level-trending').nextAll('.star-level-note:first').removeClass('hidden');

			if (Adzuki.is_mobile === true || screen.width < 1500) {
				Adzuki.QTip.attachQtip(undefined, undefined, undefined, 'left');
			} else {
				Adzuki.QTip.attachQtip();
			}
		});
	}

	function selectSoarFilter(ev)
	{
		var filter       = $(this).data('filter');
		var filter_name  = $(this).data('filter-name');
		var filter_value = $(this).data('filter-value');
		var filter_title = $(this).data('filter-title');
		var cur_value    = $('#soar_filter_' + filter + '_' + filter_name).val();

		if (cur_value === filter_value) {
			// existing filter clicked again, do nothing
			ev.preventDefault();
			return;
		}

		// clear the title if the filter value is "all" to not display it in the subheader
		if (filter_value === 'all') {
			filter_title = '';
		}

		$('.soar_filter[data-filter=' + filter + '][data-filter-name=' + filter_name + ']').each(function hideCheck(index, el) {
			$(el).removeClass('soar-filter-selected');
			$(el).find('i').addClass('hidden');
		});

		$(this).addClass('soar-filter-selected');
		$(this).find('i').removeClass('hidden');

		$('#soar_filter_' + filter + '_' + filter_name).val(filter_value);
		$('#soar_filter_' + filter + '_' + filter_name + '_title').val(filter_title);
		$('#soar_filter_' + filter).change();

		ev.preventDefault();
	}

	function soarFilter(ev)
	{
		var filter        = $(this).data('filter');
		var url           = $('#soar_filter_' + filter + '_url').val();
		var filter_values = [];
		var filter_titles = [];
		var that          = $(this);

		$('#' + filter + '_filter').text('Retrieving data...');

		filters[filter] = {};

		// get the values of the hidden filter inputs in the order they appear in dom
		$(this).find('input.soar_filter_input').each(
			function getFilter(index, input) {
				const name = $(input).attr('name');
				const value = $(input).val();
				filter_values.push(value);
				if (filter && value && name && name.toLowerCase().indexOf('date_range') === -1) {
					Object.assign(
						filters[filter], 
						{ 
							value: (filters[filter].value? filters[filter].value : '')+'/'+value,
						 }
					);
				}
			}
		);
			
		filters[filter].url = url; 
		filters[filter].filterDescriptions = []; 

		$(this).find('input.soar_filter_title').each(
			function getFilter(index, input) {
				const value = $(input).val();
				
				if (value !== '') {
					filter_titles.push(value);
				}
			}
		);

		// Add filter values to end of URL separated by /
		url += filter_values.join('/');

		if ($('#' + filter + '-departures').hasClass('active')) {
			url += '/departures';
		} else if ($('#' + filter + '-purchases').hasClass('active')) {
			url += '/purchases';
		}

		Adzuki.Ajax.get(url)
			.then(function populateCompleted(response) {
				$('#' + filter + '_container').html(response);
				$('#' + filter + '_filter').text(filter_titles.join(' - '));
			})
			.done(function _afterLoad() {
				if ($('.analysis-data').children().length > 0) {
					let analysis_section_name = $(ev.currentTarget).data('filter');
					let time_period           =  $(ev.currentTarget).find('input[name="date_range"]').val();

					that.find('input.soar_filter_title').each(
						function getFilter(index, input) {
							const value = $(input).val();
							
							if (value !== '') {
								const dates = value.match(/\(([0-9\/\s]+)-([0-9\/\s]+)\)/); 
			
								if (dates !== null) {
									$('#' + filter + '_date_from').val(dates[1].trim());
									$('#' + filter + '_date_to').val(dates[2].trim());
								}
							}
						}
					);

					renderChartBySection(analysis_section_name, time_period);
				}
			});

		if (sectionName) {
			$('.' + sectionName + '_filter').removeClass('hidden');
			$('.' + sectionName + '_filter_dates').addClass('hidden');
		}

		ev.preventDefault();
	}

	function renderChartBySection(analysis_section_name, time_period)
	{
		google.charts.load('current', {packages: ['corechart']});

		const parts = analysis_section_name.split('_');
		let chart_type = parts[0] + parts[1].substr(0, 1).toUpperCase() + parts[1].substr(1);

		renderAnalysisChart(chart_type, 'departures', time_period);
		renderAnalysisChart(chart_type, 'purchases', time_period);
	}
}(jQuery, window.Adzuki || {}));
